import css from './PaymentAmount.module.css';

const PaymentAmount = ({text, onClick=()=>{}, style={}, nodollar=false}) => {
	return (
		<span className={css.container} style={style} onClick={onClick}>{`${nodollar ? '' : '$'}${text}`}</span>
	);
};

export default PaymentAmount;
